__turbopack_context__.v({
  "linkButton": "_2SoGAG_linkButton",
  "linkButtonActive": "_2SoGAG_linkButtonActive",
  "menuList": "_2SoGAG_menuList",
});
